import { ReactNode } from 'react';

export interface ToastNotificationProps {
  title?: string;
  message?: ReactNode;
}

export function ToastNotification(props: ToastNotificationProps) {
  const { title = '', message = '' } = props;

  return (
    <div>
      {title && (
        <div>
          <strong>{title}</strong>
        </div>
      )}

      {message && <div>{message}</div>}
    </div>
  );
}
